import ImageWithFallback from './ImageWithFallback';
interface GeniusLogoProps {
  className?: string;
  size?: number;
  variant?: 'white' | 'pink';
}
const GeniusLogo = ({
  size = 12,
  className,
  variant = 'pink'
}: GeniusLogoProps) => {
  const getGeniusURL = () => {
    if (variant === 'white') {
      return '/static/genius-white.svg';
    }
    return '/static/genius.svg';
  };
  return <ImageWithFallback src={getGeniusURL()} width={size} height={size} alt='genius-logo' className={className} data-sentry-element="ImageWithFallback" data-sentry-component="GeniusLogo" data-sentry-source-file="GeniusLogo.tsx" />;
};
export default GeniusLogo;